import { useId, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { inputClass } from "../../components/ui";
import { DOCS } from "../../docs";

/**
 * The documentation library: every customer-facing document under one
 * left-hand navigation, release notes included, so no page reads as an
 * orphan. The filter matches title and summary; four entries today, more
 * later, which is the point of building the shelf before it is full.
 */
export const LIBRARY = [
  ...DOCS.map((d) => ({ to: `/docs/${d.slug}`, title: d.title, summary: d.summary })),
  { to: "/docs/release-notes", title: "Release notes", summary: "What changed in each version of the portal and of the customer template." },
] as const;

export function DocsLayout() {
  const [term, setTerm] = useState("");
  const id = useId();
  const needle = term.trim().toLowerCase();
  const shown = needle ? LIBRARY.filter((e) => `${e.title} ${e.summary}`.toLowerCase().includes(needle)) : LIBRARY;
  return (
    <div className="md:grid md:grid-cols-[14rem_minmax(0,1fr)] md:items-start md:gap-8">
      <nav aria-label="Documentation" className="mb-6 md:sticky md:top-4 md:mb-0 md:max-h-[calc(100vh-2rem)] md:overflow-y-auto">
        <label htmlFor={id} className="sr-only">
          Filter documentation
        </label>
        <input id={id} type="search" value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Filter" className={`${inputClass} mb-3`} />
        <ul className="flex gap-1 overflow-x-auto md:flex-col md:gap-0.5">
          {shown.map((e) => (
            <li key={e.to} className="shrink-0">
              <NavLink
                to={e.to}
                className={({ isActive }) => `block whitespace-nowrap border-l-2 py-1.5 pl-2.5 pr-2 text-sm leading-5 md:whitespace-normal hover:border-neutral-400 dark:hover:border-neutral-600 ${isActive ? "border-brand-text font-semibold text-brand-text" : "border-transparent text-neutral-700 dark:text-neutral-300"}`}
                title={e.summary}
              >
                {e.title}
              </NavLink>
            </li>
          ))}
          {shown.length === 0 && <li className="px-2.5 py-1.5 text-sm text-neutral-500">Nothing matches.</li>}
        </ul>
      </nav>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
